import React from "react";

import { CgSpinner } from "react-icons/cg";

import { ISpinnerProps } from "./types";

export const Spinner = (props: ISpinnerProps) => {
  const { color, size, className } = props;

  return (
    <CgSpinner
      color={color || "#00535c"}
      size={size || "28px"}
      className={`${className || ""} animate-spin`}
    />
  );
};
